import ContractDeadlineCostComponent from './components/blue/contract-deadline-cost.vue'

export default {
  // 蓝主人合约——期限和费用 组件
  ContractDeadlineCost:ContractDeadlineCostComponent
}


// WEBPACK FOOTER //
// ./src/components-mapper.js